import { ApolloLink } from '@apollo/client';
import { auth, shareAuth } from '@frameio/utils/auth';

/**
 * adds custom headers after the unidentified user submits their identity
 */
export const shareUnidentifiedUserLink = (shareId: string) => {
  return new ApolloLink((operation, forward) => {
    const authToken = auth.getAccessToken();
    const userId = shareAuth.getIdentifiedUserId();
    const identifiedUserSessionId = shareAuth.getIdentifiedUserSessionId();
    const headers = operation?.getContext()?.headers;

    /**
     * An auth token can exist if a user happens to identify themselves in
     * a V3 Review link. When they do this, V3 stores the auth token in the
     * same cookie key that Authenticated Users use, so it will come back as
     * authToken. We are choosing to allow the `userId` to still be sent.
     */
    if (userId) {
      headers[`${shareAuth.X_IDENTIFIED_USER_HEADER}`] = userId;
    } else if (authToken) {
      delete headers[shareAuth.X_IDENTIFIED_USER_HEADER];
      shareAuth.removeIdentifiedUserId(shareId);
    }

    if (identifiedUserSessionId) {
      headers[`${shareAuth.X_IDENTIFIED_USER_SESSION_ID_HEADER}`] =
        identifiedUserSessionId;
    }

    operation?.setContext({ headers });
    return forward(operation);
  });
};
